import Login from '@/shared/api/login';

export interface RipplingHandoverResponse {
  nonce: string;
  role_id: string;
}

export async function fetchRipplingHandoverToken(): Promise<RipplingHandoverResponse> {
  return await Login.url('/rippling-handover').post({});
}
